import { render, staticRenderFns } from "./IconDotsHorizontalOutline.vue?vue&type=template&id=616b537a"
import script from "./IconDotsHorizontalOutline.vue?vue&type=script&lang=js"
export * from "./IconDotsHorizontalOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports